<template>

    <div>

        <div :id="id+'-struct'" class="trax-collapse">
            <div class="card-collapse clearfix" v-for="(domainName, typeCode) in competency_domains_names" :key="typeCode" v-if="visibleCompetency(typeCode)">

                <button class="btn-default btn btn-link btn-just-icon float-left mt-2" @click="openCompetencies(typeCode)" v-if="!editDisabled">
                    <i class="material-icons">edit</i>
                </button>

                <div :class="headerClass">
                    <h5 class="mb-1">{{ domainName }}</h5>
                </div>

                <div :id="id+'-struct-'+typeCode" :class="bodyClass" v-if="states[typeCode]">

                    <div class="trax-text-small mb-2" v-for="(item, index) in states[typeCode].indicators" :key="index" v-if="states[typeCode].indicators && item">
                        <i class="material-icons text-danger pr-2" v-if="item == 1">error_outline</i> 
                        <i class="material-icons text-success pr-2" v-if="item == 3">check</i> 
                        {{ indicators ? indicators[index] : '' }}
                    </div>

                    <div class="" v-if="states[typeCode].comments">
                        <i class="material-icons">format_quote</i> 
                        <span style="font-style:italic;color:#999;white-space:pre-wrap;">{{ states[typeCode].comments }}</span>
                    </div>
                </div>

            </div>
        </div>

    </div>

</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-procedure-atp-daf-edit-competencies'},
            states: null,
            indicators: null,
            editDisabled: null,
            bus: null
        },

        data: function() {
            return {
                competency_domains_names: data.competency_domains_names,
            }
        },

        computed: {

            headerClass: function() {
                var res = 'card-header pt-3';
                if (!this.editDisabled) res += ' ml-5';
                return res;
            },

            bodyClass: function() {
                var res = 'card-body pt-3 pl-2';
                if (!this.editDisabled) res += ' ml-5';
                return res;
            }
        },

        created: function() {
            var that = this;
            this.bus.$on(this.id+'-view-force-update', function() {
                that.$forceUpdate();
            });
        },

        methods: {

            visibleCompetency(typeCode) {
                return !this.editDisabled || (this.states[typeCode] && (
                    (this.states[typeCode].comments && this.states[typeCode].comments.trim() != '')
                    || (this.states[typeCode].indicators && Object.keys(this.states[typeCode].indicators).length)
                ));
            },

            visibleEditedCompetency(typeCode) {
                return (this.states[typeCode] && (
                    (this.states[typeCode].comments && this.states[typeCode].comments.trim() != '')
                    || (this.states[typeCode].indicators && Object.keys(this.states[typeCode].indicators).length)
                ));
            },

            openCompetencies(typeCode) {
                var states = this.states[typeCode] ? this.states[typeCode] : {indicators: {}};
                this.bus.$emit(this.id+'-select-open', {
                    title: this.competency_domains_names[typeCode],
                    data: {type_code: typeCode, states: states }
                });
            }
        }

    }
</script>
